export const getComponentValue = (id, settings = null) => {
    if (!settings) {
        if (!localStorage.getItem("settings")) {
            localStorage.setItem("settings", JSON.stringify(defaultSettings));
        }
        settings = JSON.parse(localStorage.getItem("settings"));
    }
    for (const item of settings) {
        if (item.id === id) {
            return item.value;
        }
    }
    return null;
}

export const setComponentValue = (id, value, type) => {
    if (!localStorage.getItem("settings")) {
        localStorage.setItem("settings", JSON.stringify(defaultSettings));
    }
    let settings = JSON.parse(localStorage.getItem("settings"));
    for (const item of settings) {
        if (item.id === id) {
            if (type === "switch") {
                item.value = !item.value;
            } else {
                item.value = value;
            }
            break;
        }
    }
    return settings;
}

export const setConfigValue = (id, value, child, type) => {
    if (!localStorage.getItem("settings")) {
        localStorage.setItem("settings", JSON.stringify(defaultSettings));
    }
    let settings = JSON.parse(localStorage.getItem("settings"));
    for (const item of settings) {
        if (item.id === id) {
            for (const itemConfig of item.config) {
                if (itemConfig.id === child) {
                    if (type === "switch") {
                        itemConfig.value = !itemConfig.value;
                    } else {
                        itemConfig.value = value;
                    }
                }
            }
            break;
        }
    }
    return settings;
}

export const getConfigComponent = (id, settings = null) => {
    if (!settings) {
        if (!localStorage.getItem("settings")) {
            localStorage.setItem("settings", JSON.stringify(defaultSettings));
        }
        settings = JSON.parse(localStorage.getItem("settings"));
    }
    for (const item of settings) {
        if (item.id === id) {
            return item.config;
        }
    }
    return null;
}

export const defaultSettings = [
    {
        id: "animation",
        component: "dropdown",
        color: "blue",
        value: "fadein",
        description: { es: "Animaciones del fondo: ", us: "Animation background: " },
        search: true,
        options: {
            es: [
                { key: 'none', value: 'none', flag: null, text: 'Ninguna' },
                { key: 'fadein', value: 'fadein', flag: null, text: 'FadeIn' },
                { key: 'slideup', value: 'slideup', flag: null, text: 'SlideUp' },
                { key: 'slideright', value: 'slideright', flag: null, text: 'SlideRight' },
                { key: 'slidedown', value: 'slidedown', flag: null, text: 'SlideDown' },
                { key: 'slideleft', value: 'slideleft', flag: null, text: 'SlideLeft' },
                { key: 'zoom', value: 'zoom', flag: null, text: 'Zoom' },
                { key: 'clip', value: 'clip', flag: null, text: 'Clip' },
                { key: 'puff', value: 'puff', flag: null, text: 'Puff' },
            ],
            us: [
                { key: 'none', value: 'none', flag: null, text: 'Ninguna' },
                { key: 'fadein', value: 'fadein', flag: null, text: 'FadeIn' },
                { key: 'slideup', value: 'slideup', flag: null, text: 'SlideUp' },
                { key: 'slideright', value: 'slideright', flag: null, text: 'SlideRight' },
                { key: 'slidedown', value: 'slidedown', flag: null, text: 'SlideDown' },
                { key: 'slideleft', value: 'slideleft', flag: null, text: 'SlideLeft' },
                { key: 'zoom', value: 'zoom', flag: null, text: 'Zoom' },
                { key: 'clip', value: 'clip', flag: null, text: 'Clip' },
                { key: 'puff', value: 'puff', flag: null, text: 'Puff' },
            ],
        },
    },
    {
        id: "autoHide",
        component: "switch",
        color: "brown",
        value: false,
        description: { es: "Ocultar después de 5 segundos: ", us: "Auto hide after 5 seconds: " },
        option_1: { es: "Off", us: "Off" },
        option_2: { es: "On", us: "On" },
    },
    {
        id: "showApps",
        component: "switch",
        color: "violet",
        value: true,
        description: { es: "Mostrar enlaces de Apps: ", us: "Show Apps links: " },
        option_1: { es: "Ocultar", us: "Hide" },
        option_2: { es: "Mostrar", us: "Show" },
    },
    {
        id: "configApps",
        component: "multioptions",
        color: "orange",
        description: { es: "Configuración de Apps", us: "Configuration Apps" },
        config: [
            { id: "backgroundPopupApps", description: { es: "Color de fondo: ", us: "Background color: " }, component: "colorPicker", value: '#000000a8' },
            { id: "textPopupApps", description: { es: "Color de texto: ", us: "Text color: " }, component: "colorPicker", value: '#ffffff' },
            { id: "borderPopupApps", description: { es: "Color de la sombra: ", us: "Box shadow color: " }, component: "colorPicker", value: '#000000' },
            { id: "textLinksPopupApps", description: { es: "Color de los enlaces: ", us: "Text links color: " }, component: "colorPicker", value: '#ffffff' },
        ]
    },
    {
        id: "showFavorites",
        component: "switch",
        color: "violet",
        value: true,
        description: { es: "Mostrar enlaces de Favoritos: ", us: "Show Favorite links: " },
        option_1: { es: "Ocultar", us: "Hide" },
        option_2: { es: "Mostrar", us: "Show" },
    },
    {
        id: "configFavorites",
        component: "multioptions",
        color: "orange",
        description: { es: "Configuración de Favoritos", us: "Configuration Favorites" },
        config: [
            { id: "backgroundPopupFavorite", description: { es: "Color de fondo: ", us: "Background color: " }, component: "colorPicker", value: '#000000a8' },
            { id: "textPopupFavorite", description: { es: "Color de texto: ", us: "Text color: " }, component: "colorPicker", value: '#ffffff' },
            { id: "borderPopupFavorite", description: { es: "Color de la sombra: ", us: "Box shadow color: " }, component: "colorPicker", value: '#000000' },
            { id: "textLinksPopupFavorite", description: { es: "Color del los enlaces: ", us: "Text links color: " }, component: "colorPicker", value: '#ffffff' },
        ]
    },
    {
        id: "showFooter",
        component: "switch",
        color: "red",
        value: true,
        description: { es: "Mostrar pie de página: ", us: "Show footer: " },
        option_1: { es: "Ocultar", us: "Hide" },
        option_2: { es: "Mostrar", us: "Show" },
    },
    {
        id: "configFooter",
        component: "multioptions",
        color: "orange",
        description: { es: "Configuración del pie de página", us: "Configuration Footer" },
        config: [
            { id: "backgroundFooter", description: { es: "Color de fondo: ", us: "Background color: " }, component: "colorPicker", value: '#00000000' },
            { id: "showGroupsFooter", component: "switch", color: "green", value: true, description: { es: "Mostrar nombres de grupos: ", us: "Show groups names: " }, option_1: { es: "No", us: "Hide" }, option_2: { es: "Si", us: "Show" } },
            { id: "textFooter", description: { es: "Color de texto: ", us: "Text color: " }, component: "colorPicker", value: '#ffffff' },
            { id: "borderPopupFooter", description: { es: "Color de la sombra: ", us: "Box shadow color: " }, component: "colorPicker", value: '#000000' },
        ]
    },
    {
        id: "language",
        component: "dropdown",
        color: "pink",
        value: "us",
        description: { es: "Seleccionar el idioma: ", us: "Select language: " },
        search: false,
        options: {
            es: [
                { key: 'es', value: 'es', flag: 'es', text: 'Español' },
                { key: 'us', value: 'us', flag: 'us', text: 'English' },
            ],
            us: [
                { key: 'es', value: 'es', flag: 'es', text: 'Español' },
                { key: 'us', value: 'us', flag: 'us', text: 'English' },
            ],
        }
    },
    {
        id: "formatTime",
        component: "switch",
        color: "red",
        value: true,
        description: { es: "Cambiar formato de hora: ", us: "Change format time: " },
        option_1: { es: "12h", us: "12h" },
        option_2: { es: "24h", us: "24h" },
    },
    {
        id: "formatDate",
        component: "dropdown",
        color: "blue",
        value: "dd.mm.yyyy",
        description: { es: "Cambiar formato de fecha: ", us: "Change format date: " },
        search: false,
        options: {
            es: [
                { key: 'dd.mm.yyyy', value: 'dd.mm.yyyy', flag: null, text: 'dd.mm.yyyy' },
                { key: 'mm.dd.yyyy', value: 'mm.dd.yyyy', flag: null, text: 'mm.dd.yyyy' },
                { key: 'yyyy.mm.dd', value: 'yyyy.mm.dd', flag: null, text: 'yyyy.mm.dd' },
            ],
            us: [
                { key: 'dd.mm.yyyy', value: 'dd.mm.yyyy', flag: null, text: 'dd.mm.yyyy' },
                { key: 'mm.dd.yyyy', value: 'mm.dd.yyyy', flag: null, text: 'mm.dd.yyyy' },
                { key: 'yyyy.mm.dd', value: 'yyyy.mm.dd', flag: null, text: 'yyyy.mm.dd' },
            ],
        }
    },
    {
        id: "blindFilter",
        component: "dropdown",
        color: "yellow",
        value: "none",
        description: { es: "Filtros para daltónicos: ", us: "Color blind filter: " },
        search: true,
        options: {
            es: [
                { key: 'none', value: 'none', flag: null, text: 'None' },
                { key: 'protanopia', value: 'protanopia', flag: null, text: 'Protanopia' },
                { key: 'protanomaly', value: 'protanomaly', flag: null, text: 'Protanomaly' },
                { key: 'deuteranopia', value: 'deuteranopia', flag: null, text: 'Deuteranopia' },
                { key: 'deuteranomaly', value: 'deuteranomaly', flag: null, text: 'Deuteranomaly' },
                { key: 'tritanopia', value: 'tritanopia', flag: null, text: 'Tritanopia' },
                { key: 'tritanomaly', value: 'tritanomaly', flag: null, text: 'Tritanomaly' },
                { key: 'achromatopsia', value: 'achromatopsia', flag: null, text: 'Achromatopsia' },
                { key: 'achromatomaly', value: 'achromatomaly', flag: null, text: 'Achromatomaly' },
            ],
            us: [
                { key: 'none', value: 'none', flag: null, text: 'None' },
                { key: 'protanopia', value: 'protanopia', flag: null, text: 'Protanopia' },
                { key: 'protanomaly', value: 'protanomaly', flag: null, text: 'Protanomaly' },
                { key: 'deuteranopia', value: 'deuteranopia', flag: null, text: 'Deuteranopia' },
                { key: 'deuteranomaly', value: 'deuteranomaly', flag: null, text: 'Deuteranomaly' },
                { key: 'tritanopia', value: 'tritanopia', flag: null, text: 'Tritanopia' },
                { key: 'tritanomaly', value: 'tritanomaly', flag: null, text: 'Tritanomaly' },
                { key: 'achromatopsia', value: 'achromatopsia', flag: null, text: 'Achromatopsia' },
                { key: 'achromatomaly', value: 'achromatomaly', flag: null, text: 'Achromatomaly' },
            ],
        }
    },
    {
        id: "darkMode",
        component: "switch",
        color: "black",
        value: false,
        description: { es: "Modo oscuro: ", us: "Dark Mode: " },
        option_1: { es: "Off", us: "Off" },
        option_2: { es: "On", us: "On" },
    },
    {
        id: "exportConfig",
        component: "multioptions",
        color: "blue",
        description: { es: "Configuración del Exportar", us: "Export Configuration" },
        config: [
            { id: "exportBackground", component: "switch", color: "violet", value: true, description: { es: "Exportar fondos: ", us: "Export backgrounds: " }, option_1: { es: "No", us: "No" }, option_2: { es: "Si", us: "Yes" } },
            { id: "exportFavorites", component: "switch", color: "pink", value: true, description: { es: "Exportar favoritos: ", us: "Export favorites: " }, option_1: { es: "No", us: "No" }, option_2: { es: "Si", us: "Yes" } },
            { id: "exportSettings", component: "switch", color: "green", value: true, description: { es: "Exportar configuración: ", us: "Export settings: " }, option_1: { es: "No", us: "No" }, option_2: { es: "Si", us: "Yes" } },
            { id: "btnExport", component: "button", color: "violet", value: true, description: { es: "Exportar", us: "Export" } },
        ]
    },
    {
        id: "importConfig",
        component: "import",
        color: "red",
        description: { es: "Importar configuración", us: "Import configuration" },
        config: [
            // { id: "backgroundFooter", description: "Background color: ", component: "colorPicker", value: '#cfcfcf99' },
            // { id: "showGroupsFooter", description: "Show groups names: ", component: "switch", options: '' },
            // { id: "textFooter", description: "Text color: ", component: "colorPicker", value: '#000000' },
        ]
    },
    {
        id: "support",
        component: "buttonSupport",
        color: "pink",
        description: { es: "Donar a través de PayPal: ", us: "Support via PayPal: " },
        content: { es: "Donar", us: "Support" },
    },
]